export class NotificationSearchFilter {
    userId: number;
    notificationId: boolean;
    isRead: boolean;
}